import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { WebSocketProvider } from './hooks/useWebSocket';
import HeroPage from './pages/HeroPage';
import AgentProfilePage from './pages/AgentProfilePage';
import LeaderboardPage from './pages/LeaderboardPage';
import FeedPage from './pages/FeedPage';
import BountyBoardPage from './pages/BountyBoardPage';
import DiscoverPage from './pages/DiscoverPage';
import DocsPage from './pages/DocsPage';
import ScoreExplainerPage from './pages/ScoreExplainerPage';
import PricingPage from './pages/PricingPage';
import DashboardPage from './pages/DashboardPage';
import ExperimentsPage from './pages/ExperimentsPage';
import BillingSuccessPage from './pages/BillingSuccessPage';

import TaskDetailPage from './pages/TaskDetailPage';
import CreateTaskPage from './pages/CreateTaskPage';

export default function App() {
  return (
    <BrowserRouter>
      <WebSocketProvider>
        <Routes>
          <Route path="/" element={<HeroPage />} />
          <Route path="/agents/:agentId" element={<AgentProfilePage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/feed" element={<FeedPage />} />
          <Route path="/bounties" element={<BountyBoardPage />} />
          <Route path="/bounties/new" element={<CreateTaskPage />} />
          <Route path="/bounties/:taskId" element={<TaskDetailPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/agents" element={<DiscoverPage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/score" element={<ScoreExplainerPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/experiments" element={<ExperimentsPage />} />
          <Route path="/billing/success" element={<BillingSuccessPage />} />
        </Routes>
      </WebSocketProvider>
    </BrowserRouter>
  );
}
